import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import axios from "axios";
import Vue from "vue";

const SettingsRepository = RepositoryFactory.get('settings');
const ServiceRepository = RepositoryFactory.get('services');

const state = {
    modules: null,
    positions: null,
    publisher: null,
    sizes: null,
    selectedItem: null,
    selectedDetails: null,
    activeTab: null,
    sites: null,
    targetings: null,
    targetingsByPublisher: null,
    loading: {
        site: false,
        sites: false,
    }
}
const getters = {}

const actions = {
    async fetchConfig({commit}) {
        let {data} = await SettingsRepository.getConfig()
        if (data.Status) {
            commit('setConfig', data);
        }
    },
    async fetchAllSites({commit, rootState}) {
        let reqs = [];
        state.loading.sites = true;
        if (rootState.display.publisher) {
            rootState.display.publisher.forEach((publ) => {
                reqs.push(SettingsRepository.getAllSites(publ.PublisherId));
            });
            await axios.all(reqs).then(axios.spread((...responses) => {
                let sites = [];
                if (responses) {
                    responses.forEach((res) => {
                        if (typeof res.data !== "undefined" && typeof res.data.sites !== "undefined") {
                            sites = sites.concat(res.data.sites);
                        }
                    });
                }
                commit('setSites', sites);
                state.loading.sites = false;
            }))
        }
    },
    async createSite({dispatch}, payload) {
        let {data} = await ServiceRepository.createSite(payload);
        if (data.Status) {
            dispatch('fetchAllSites');
        }
        return data;
    },
    async editSite({dispatch}, payload) {
        let {data} = await ServiceRepository.editSite(payload);
        if (data.Status) {
            dispatch('fetchAllSites');
        }
        return data;
    },
    async copySite({dispatch}, payload) {
        let {data} = await ServiceRepository.copySite(payload);
        if (data.Status) {
            dispatch('fetchAllSites');
        }
        return data;
    },
    async deleteSite({dispatch}, payload) {
        let {data} = await ServiceRepository.deleteSite(payload);
        if (data.Status) {
            dispatch('fetchAllSites');
        }
        return data;
    },
    async fetchSiteDetails({state, commit}) {
        if (state.loadingSite) state.siteCancelToken.cancel('getTypesAndDetails cancel');
        state.loading.site = true;
        state.siteCancelToken = axios.CancelToken.source();
        try {
            let {data} = await ServiceRepository.getSiteDetails(state.selectedItem.SiteId, state.siteCancelToken.token);
            if (data.Status) {
                commit('updateSelectedDetails', data);
                state.loading.site = false;
            }
        } catch
            (e) {
            state.loading.site = false;
        }
    },
    async fetchSizeDetails({commit}) {
        let {data} = await SettingsRepository.getSizeDetails(state.selectedItem.ConfigSizeId)
        if (data.Status) {
            commit('updateSelectedDetails', data.Size);
        }
        return data;
    },
    async editSize(context, payload) {
        let {data} = await SettingsRepository.editSize(payload)
        if (data.Status) {
            state.sizes = data.Sizes;
        }
        return data;
    },
    async deleteSize(context, payload) {
        let {data} = await SettingsRepository.deleteSize(payload)
        if (data.Status) {
            state.sizes = data.Sizes;
        }
        return data;
    },
    async fetchPublisherDetails({commit}) {
        let {data} = await SettingsRepository.getPublisherDetails(state.selectedItem.PublisherId)
        if (data.Status) {
            commit('updateSelectedDetails', data.Publisher);
        }
        return data;
    },
    async editPublisher(context, payload) {
        let {data} = await SettingsRepository.editPublisher(payload)
        if (data.Status) {
            state.publisher = data.Publisher;
        }
        return data;
    },
    async deletePublisher(context, payload) {
        let {data} = await SettingsRepository.deletePublisher(payload)
        if (data.Status) {
            state.publisher = data.Publisher;
        }
        return data;
    },
    async fetchPositionsDetails({commit}) {
        let {data} = await SettingsRepository.getPositionsDetails(state.selectedItem.ConfigPositionnameId)
        if (data.Status) {
            commit('updateSelectedDetails', data.Position);
        }
        return data;
    },
    async editPosition(context, payload) {
        let {data} = await SettingsRepository.editPosition(payload)
        if (data.Status) {
            state.positions = data.Positions;
        }
        return data;
    },
    async deletePosition(context, payload) {
        let {data} = await SettingsRepository.deletePosition(payload)
        if (data.Status) {
            state.positions = data.Positions;
        }
        return data;
    },
    async fetchModuleDetails({commit}) {
        let {data} = await SettingsRepository.getModuleDetails(state.selectedItem.ModuleId)
        if (data.Status) {
            commit('updateSelectedDetails', data.Module);
        }
        return data;
    },
    async deleteModule(context, payload) {
        let {data} = await SettingsRepository.deleteModule(payload)
        if (data.Status) {
            state.modules = data.Modules;
        }
        return data;
    },
    async updateSelected({commit, dispatch}, payload) {
        await commit('updateSelectedItem', payload.item);
        if (payload.item && payload.fetchDetails) {
            dispatch(payload.fetchDetails);
        } else {
            commit('updateSelectedDetails', null)
        }
    },
    async fetchGeneralTargetingList({commit}) {
        let {data} = await SettingsRepository.getGeneralTargetingList();
        if (data.Status) {
            commit('updateTargetings', data.Targetings);
        }
        return data;
    },
    async fetchTargetingListByPublisherId({commit}, payload) {
        let {data} = await SettingsRepository.getTargetingListByPublisherId(payload);
        if (data.Status) {
            commit('updateTargetingsByPublisher', data.Targeting);
        }
        return data;
    },
    async editTargeting(context, payload) {
        let {data} = await SettingsRepository.editTargeting(payload)
        if (data.Status) {
            state.targetings = data.Targetings;
        }
        return data;
    },
    async deleteTargeting(context, payload) {
        let {data} = await SettingsRepository.deleteTargeting(payload)
        if (data.Status) {
            state.targetings = data.Targetings;
        }
        return data;
    },
}
const mutations = {
    setConfig(state, payload) {
        state.modules = payload.Modules;
        state.positions = payload.Positions;
        state.publisher = payload.Publisher;
        state.sizes = payload.Sizes;
    },
    setSites(state, payload) {
        state.sites = payload;
    },
    setTypes(state, payload) {
        Vue.set(state.selectedDetails, 'Types', payload);
    },
    updateSelectedItem(state, payload) {
        state.selectedItem = payload;
    },
    updateSelectedDetails(state, payload) {
        state.selectedDetails = payload;
    },
    updateActiveTab(state, payload) {
        state.activeTab = payload;
    },
    updateTargetings(state, payload) {
        state.targetings = payload;
    },
    updateTargetingsByPublisher(state, payload) {
        state.targetingsByPublisher = payload;
    },
    resetSelected(state) {
        state.selectedDetails = null;
        state.selectedItem = null;
    },
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}